<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">Associa analisi</h4>
  <button type="button" class="text-white close" aria-label="Close" (click)="modal.close({isEdited:edited})">
    <span aria-hidden="true">&times;</span>
</button>
</div>

<div class="modal-body">
  <fieldset>
      <div class="form-group col mb-3">
          <label for="id_gruppo">Selezione Gruppi</label>
          <select 
            class="custom-select" 
            id="id_gruppo" 
            name="id_gruppo" 
            (ngModelChange)="onChange($event)"
            [(ngModel)]="selectedGroup">

              <option value="-1">-</option>
              <option *ngFor="let field of groupsList" [value]="field.id">{{ field.name }}</option>
          </select>
      </div>
      
      <hr>
 
      <div class="customContainer">
        <ng-container *ngIf="linkedGroupsObj.length > 0">
          <div class="row mt-2 w-100">
            <div class="col-12">
                <ul class="ul-group">
                    <li *ngFor="let group of linkedGroupsObj; let i = index" class="d-flex justify-content-between">
                        <div class="w-75 d-inline w-break-all d-flex align-items-center">
                            {{group.name}}
                        </div>
                        <div role="button" class="w-25 d-inline p-2 txt-bg-blu d-flex align-items-center" (click)="removeGroup(i, group.id)">
                            <fa-icon aria-hidden="true" [icon]="faTrash"></fa-icon>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        </ng-container>

      </div>
     
  </fieldset>
</div>

<div class="modal-footer">
  <button type="button" class="btn bg-blu txt-white" (click)="onSubmit()">Salva</button>
  <button type="button" class="btn btn-bg-outline" (click)="modal.close({isEdited:edited})">
    Chiudi
  </button>
</div>